export const WINDOW_ACTIVATION_DELAY = 300;
export const DesktopBxLink = {
	chat: 'chat',
	lines: 'lines',
	call: 'call',
	phone: 'phone',
	conference: 'conference',
	callList: 'callList',
	notifications: 'notifications',
	recentSearch: 'recentSearch',
	timeManager: 'timemanpwt',
	copilot: 'copilot',
	collab: 'collab',
	channel: 'channel',
	taskComments: 'taskComments',
	settings: 'settings',
	openTab: 'openTab',
	openPage: 'openPage',
	chatCreation: 'chatCreation',
	chatUpdate: 'chatUpdate',
	botContext: 'botContext',
	openLayout: 'openLayout',
};

export const LegacyDesktopBxLink = {
	messenger: 'messenger',
	chat: 'chat',
	videoconf: 'videoconf',
	notify: 'notify',
	callTo: 'callto',
	callList: 'calllist',
};

export const DesktopBroadcastAction = {
	notification: 'notification',
	answerButtonClick: 'answerButtonClick',
	bxLink: 'bxLink',
};